import { Picture, Text, ResponsiveFloraTypography } from 'ui/components/primitives';
import { CheckSingleIcon } from '@grupoboticario/flora-react-icons';
import { pluralize } from 'ui/utilities/helpers/pluralize';
import Styles from './Combo.components.styles';
import type { ComboProductsProps } from './Combo.components.d';

const ComboProducts = ({ products }: ComboProductsProps) => (
  <>
    {products.map(({ available, code, image, name, totalQuantity }) => (
      <Styles.Skus key={`product-${code}`}>
        <ResponsiveFloraTypography as="h6" fontSize="subtitle" css={{ margin: 0 }}>
          O produto {name} não tem variação
        </ResponsiveFloraTypography>
        <Styles.Tag data-completed>
          <CheckSingleIcon size={12} />
          <Text variant="auxiliar-small">{`${totalQuantity} ${pluralize(
            totalQuantity,
            'item será adicionado junto com o combo',
            'itens serão adicionados junto com o combo',
          )}`}</Text>
        </Styles.Tag>

        <Styles.Slider>
          <Styles.Sku spacing="small">
            <Picture
              alt={name}
              opacity={available ? '100' : '25'}
              ratio="4x3"
              sources={[
                {
                  srcSet: `${image}`,
                },
              ]}
              src={image}
            />
            <Styles.Text variant="body-medium-short">{name}</Styles.Text>
          </Styles.Sku>
        </Styles.Slider>
      </Styles.Skus>
    ))}
  </>
);

export default ComboProducts;
